import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {Toolbar} from './components/toolbar/Toolbar'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'
import {DrawerMessenger, ActivityDrawer, Main, InviteUsers, UpgradePlan} from '../partials'
import {DrawerComponent, MenuComponent} from '../assets/ts/components'
import ApiStatusNotification from '../../components/ApiStatusNotification'
import SocketNotificationProvider from '../../components/SocketNotificationProvider'
import {FloatingConnectedUsers, CHAT_MESSAGING_ENABLED} from '../../components/ConnectedUsers'
import {ActiveConversationProvider} from '../../contexts/ActiveConversationContext'

const MasterLayout = () => {
  const location = useLocation()

  /** WebKit (Safari): splash or a stray Metronic drawer overlay can sit above the app and eat all clicks. */
  useEffect(() => {
    const clearBlockingLayers = () => {
      const splash = document.getElementById('splash-screen')
      if (splash) {
        splash.style.setProperty('display', 'none')
        splash.style.setProperty('pointer-events', 'none')
      }
      document.body.classList.remove('page-loading')
      document.body.removeAttribute('data-kt-drawer')
      document.body.removeAttribute('data-kt-drawer-aside')
      document.body.removeAttribute('data-kt-drawer-header-menu')
      try {
        DrawerComponent.hideAll()
      } catch {
        /* ignore */
      }
      document.querySelectorAll('body > .drawer-overlay').forEach((el) => el.remove())
    }
    clearBlockingLayers()
    const t0 = window.setTimeout(clearBlockingLayers, 0)
    const t1 = window.setTimeout(clearBlockingLayers, 550)
    return () => {
      window.clearTimeout(t0)
      window.clearTimeout(t1)
    }
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <ActiveConversationProvider>
      <SocketNotificationProvider>
        <PageDataProvider>
        <div className='page d-flex flex-row flex-column-fluid'>
          <AsideDefault />
          <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
            <HeaderWrapper />

            <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
              <Toolbar />
              <div className='post d-flex flex-column-fluid' id='kt_post'>
                <Content>
                  <Outlet />
                </Content>
              </div>
            </div>
            <Footer />
          </div>
        </div>

        {/* begin:: Drawers */}
        {/* <ActivityDrawer />
        <DrawerMessenger /> */}
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        {/*
        *<Main />
        <InviteUsers />
        <UpgradePlan /> */}
        {/* end:: Modals */}
        <ScrollTop />
        <ApiStatusNotification />
        {CHAT_MESSAGING_ENABLED && <FloatingConnectedUsers />}
        </PageDataProvider>
      </SocketNotificationProvider>
    </ActiveConversationProvider>
  )
}

export {MasterLayout}
